let defaultNav = {
  activeTab: 'file'
};

export default function navigationReducer(state = defaultNav, action) {
  let { type, data } = action;

  switch (type) {
    case 'UPDATE_ACTIVE_TAB':
      return Object.assign({}, state, data);

    default:
      return state;
  }
}
